<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>
 <vs-card >
      <div class="tw-flex tw-justify-between">
        <vs-select
            class=""
            label="Sayfada Gösterilecek Kayıt Sayısı"
            v-model="pageSize"
            @change="handlePageSizeChange"
        >
          <vs-select-item
              v-for="size in pageSizes"
              :key="size"
              :value="size"
              :text="size"
          />
        </vs-select>

        <vs-paginator
            v-if="meta"
            :meta="meta"
            @change="handlePageChange"
        ></vs-paginator>
      
      </div>
    </vs-card>

   

    <vs-card>
      <div slot="header">
        <div class="tw-flex tw-justify-between">
          <h3>Kullanıcılar</h3>

          <!--<vs-button
              class="butoncreate"
              :to="{name: 'users-create'}"
              style="color:white"
          >
            Kullanıcı Oluştur
          </vs-button>-->
        </div>
      </div>

      <div class="tw-flex tw-flex-wrap">
        <div class="tw-w-full tw-flex tw-justify-between tw-items-center">
          <div class="tw-flex">
             <vs-input
                placeholder="Arama (Kullanıcı Adı)"
                v-model="search"
                v-on:keyup.enter="page = 1; get();"
            />

                <v-icon  @click="page = 1; get();" small >mdi-magnify</v-icon>  

          </div>

         
        </div>

        <div class="tw-w-full">
          <vs-divider></vs-divider>
        </div>

        <div class="tw-w-full lg:tw-w-3/3">
          <div v-if="loading">Loading...</div>

          <vs-table stripe :data="list">
            <template slot="header">
              <h3>Kullanıcı Listesi</h3>
            </template>
            <template slot="thead">
             
              <vs-th>Adı</vs-th>
                <vs-th>Soyadı</vs-th>
               <vs-th>Kullanıcı Adı</vs-th>
               <vs-th>Yetki</vs-th>
              <vs-th>Email</vs-th>
              <vs-th>Birim</vs-th>
               <vs-th>Roller</vs-th>
                <vs-th>Durum</vs-th>

            
            </template>
            <template slot-scope="{data}">
              <vs-tr v-for="(item, i) in data" :key="i" >
                
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.adi }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.soyadi }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.adKullaniciAdi }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ reTur(item.turId) }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.email }}</div>
                </vs-td>
                  <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ item.fakMyo }}</div>
                </vs-td>
                 <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ checkTur(item) }}</div>
                </vs-td>
                <vs-td :data="item">
                  <div class="fontt" @click="show(item, i)">{{ aktifStr(item.eysAktiflik) }}</div>
                </vs-td>
                 <vs-td :data="item">
                <vs-button  color="#46c93a" style="color:white" icon-pack="mdi" icon="mdi-favorite" @click="duzenle(item)">Düzenle</vs-button>
                </vs-td>

              </vs-tr>
            </template>
          </vs-table>

          <!--<vs-button type="gradient" color="danger" @click="removeAll">Tümünü Sil</vs-button>-->
        </div>

        <div class="tw-w-full lg:tw-w-1/2 lg:tw-pl-5">
          <!--<vs-card v-if="selected">
            <div slot="header">
              <h3>{{ selected.username }}</h3>
            </div>
            <div>
             <p>Kullanıcı Adı: {{ selected.username }}</p>
            
              <p>Email: {{ selected.email }}</p>
             
             
            </div>
            <div slot="footer">
              <vs-row vs-justify="flex-end">
                <vs-button type="gradient" color="danger" icon-pack="mdi" icon="mdi-favorite" :to="{name: 'users-show', params: {id: selected.id}}">Düzenle</vs-button>
              </vs-row>
            </div>
          </vs-card>

          <div v-else>
            <br />
            <vs-alert active="true" color="info">
               Görüntülemek İçin Kullanıcı Seçiniz
            </vs-alert>
          </div>-->
        </div>
      </div>

    </vs-card>

  </div>
</template>

<script>
  import { paginatorMixinUs } from "@/mixins/paginatorMixinUser";
  import User from "@/libs/users/User";
   import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'

  export default {
    name: "users-index",
    title: "Kullanıcı Yetki",

    mixins: [
      paginatorMixinUs,
    ],

    data() {
      return {
        obj: new User(),
         user: getUserFromStorage(),
        search: "",
        loading: false,
      };
    },

    computed: {
      users() {
        return this.obj.users
      },

      selected() {
        return this.obj.selected
      },

      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      list() {
         if(this.user.adKullaniciAdi=="admin" ||  this.user.turId=="903" || this.user.adKullaniciAdi=="meryem.aciksoz" || this.user.adKullaniciAdi=="gokce.ozer"){
            if(this.users && this.users.data)
              return this.users.data
         }
      

        return []
      },

      meta() {
        if(this.users && this.users.meta)
          return this.users.meta

        return null
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      }
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.get()
      },

      deleted(val) {
        if(val)
          this.get()
      },
    },

    methods: {
      checkTur(temp){
        if(temp.tur){
          return temp.tur.toUpperCase()
        }
        else{ 
          ""
        }
      },
      aktifStr(temp){
        if(temp!="Silindi"){
          return "Aktif"
        }else{
return "Silindi"
}
      },
      reTur(temp){
        if(temp=='100' ||  temp=='101' || temp=='102' || temp=='103' || temp=='104' ){
            return "Personel (Akademisyen ve İdari)"
        }
        else if(temp=='904'){
            return "İdari (Birim) Admin"
        } 
        else if(temp=='905'){
            return "SKS Admin"
        }
        else if(temp=='200' || temp=='201' || temp=='202' || temp=='203' || temp=='204' || temp=='205' || temp=='206' || temp=='207'){
            return "ÖĞRENCİ"
        }
         else if(temp=='903'){
            return "Admin"
        }
         
        else{
          return "ÖĞRENCİ"
        }
      },
      duzenle(item){
                  this.$router.push({name: 'users-show', params: {id: item.id}})

      },
      get() {
        const params = this.getRequestParams(
            this.search,
            this.page,
           this.pageSize
        );

        this.loading = true
        this.obj.getAll(params)
      },

      handlePageChange(page) {
        this.page = page;
        this.get(page);
      },

      handlePageSizeChange() {
        this.page = 1;
        this.get(this.page);
      },

      refreshList() {
        this.get();
        this.obj.selected = null;
      },

      show(item, index) {
        this.obj.selected = item;
      },

      removeAll() {
        this.loading = true
        this.obj.deleteAll()
      },
    },

    mounted() {
      this.get();
      
    }
  };
</script>

<style>

</style>